import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.assign";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
/* eslint-disable react/no-unused-prop-types */


import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import React, { PureComponent } from 'react';
import { TabBarIOS } from './react-native';
var ICON_PROP_NAMES = ['iconName', 'iconSize', 'iconColor'];
var SELECTED_ICON_PROP_NAMES = [].concat(ICON_PROP_NAMES, ['selectedIconName', 'selectedIconColor']);

var arePropsEqual = function arePropsEqual(keys) {
  return function (prevProps, nextProps) {
    return isEqual(pick(prevProps, keys), pick(nextProps, keys));
  };
};

var areIconPropsEqual = arePropsEqual(ICON_PROP_NAMES);
var areSelectedIconPropsEqual = arePropsEqual(SELECTED_ICON_PROP_NAMES);
export default function createTabBarItemIOSComponent(IconNamePropType, getImageSource) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_PureComponent) {
    _inheritsLoose(TabBarItemIOS, _PureComponent);

    function TabBarItemIOS() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
      _this.state = {
        icon: undefined,
        selectedIcon: undefined
      };
      return _this;
    }

    var _proto = TabBarItemIOS.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.updateIconSource();
      this.updateSelectedIconSource();
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      if (!areIconPropsEqual(prevProps, this.props)) {
        this.updateIconSource();
      }

      if (!areSelectedIconPropsEqual(prevProps, this.props)) {
        this.updateSelectedIconSource();
      }
    };

    _proto.updateIconSource =
    /*#__PURE__*/
    function () {
      var _updateIconSource = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this$props, iconName, iconSize, iconColor, icon;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, iconName = _this$props.iconName, iconSize = _this$props.iconSize, iconColor = _this$props.iconColor;

                if (!iconName) {
                  _context.next = 8;
                  break;
                }

                _context.next = 4;
                return getImageSource(iconName, iconSize, iconColor);

              case 4:
                icon = _context.sent;
                this.setState({
                  icon: icon
                }); // eslint-disable-next-line react/destructuring-assignment

                _context.next = 9;
                break;

              case 8:
                if (this.state.icon) {
                  this.setState({
                    icon: undefined
                  });
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateIconSource() {
        return _updateIconSource.apply(this, arguments);
      }

      return updateIconSource;
    }();

    _proto.updateSelectedIconSource =
    /*#__PURE__*/
    function () {
      var _updateSelectedIconSource = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this$props2, iconName, iconColor, iconSize, selectedIconName, selectedIconColor, selectedIcon;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, iconName = _this$props2.iconName, iconColor = _this$props2.iconColor, iconSize = _this$props2.iconSize, selectedIconName = _this$props2.selectedIconName, selectedIconColor = _this$props2.selectedIconColor;

                if (!(selectedIconName || selectedIconColor)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 4;
                return getImageSource(selectedIconName || iconName, iconSize, selectedIconColor || iconColor);

              case 4:
                selectedIcon = _context2.sent;
                this.setState({
                  selectedIcon: selectedIcon
                }); // eslint-disable-next-line react/destructuring-assignment

                _context2.next = 9;
                break;

              case 8:
                if (this.state.selectedIcon) {
                  this.setState({
                    selectedIcon: undefined
                  });
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateSelectedIconSource() {
        return _updateSelectedIconSource.apply(this, arguments);
      }

      return updateSelectedIconSource;
    }();

    _proto.render = function render() {
      return React.createElement(TabBarIOS.Item, Object.assign({}, this.state, this.props));
    };

    return TabBarItemIOS;
  }(PureComponent), _class.defaultProps = {
    iconSize: 30
  }, _temp;
}